import React from 'react';
import {
    DialogActions,
    Button,
    CircularProgress,
    useTheme,
    useMediaQuery
} from '@mui/material';

const ModalActions = ({
    onClose,
    onSubmit,
    loading
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <DialogActions
            sx={{
                px: isMobile ? 2 : 3,
                pb: isMobile ? 'calc(env(safe-area-inset-bottom) + 16px)' : 3,
                pt: isMobile ? 2 : 3,
                gap: 2,
                borderTop: `1px solid ${theme.palette.divider}`,
                flexDirection: isMobile ? 'column' : 'row',
                '& > button': {
                    flex: isMobile ? 1 : 'initial',
                    width: isMobile ? '100%' : 'auto'
                }
            }}
        >
            <Button
                onClick={onClose}
                variant={isMobile ? "outlined" : "text"}
                size={isMobile ? "large" : "medium"}
                sx={{
                    borderRadius: 2,
                    px: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    order: isMobile ? 2 : 1
                }}
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={onSubmit}
                disabled={loading}
                size={isMobile ? "large" : "medium"}
                sx={{
                    borderRadius: 2,
                    px: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                    '&:hover': {
                        background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`
                    },
                    order: isMobile ? 1 : 2
                }}
                startIcon={loading ? <CircularProgress size={20} /> : null}
            >
                Add Bank Account
            </Button>
        </DialogActions>
    );
};

export default ModalActions;
